<template>
  <div>
    <select
      class="form-control custom-select"
      id="answerType"
      name="answerType"
      v-model="attributeTypeIdValue"
      @change="onAttributeTypeChanged"
    >
      <option
        :key="attributeType.id"
        :value="attributeType.id"
        v-for="attributeType in attributeTypes"
        >{{ attributeType.name }}</option
      >
    </select>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import constants from "@/entities/constants";
import { AnswerType } from "@/entities/questionaire/answers/AnswerType";

@Component
export default class AppAttributeTypeSelector extends Vue {
  private attributeTypeIdValue: string = "";
  private attributeTypes: { id: string; name: string }[] = [];

  @Watch("attributeTypeIdValue")
  onAttributeTypeChanged() {
    this.$emit("input", this.attributeTypeIdValue);
  }

  created() {
    this.attributeTypes = [
      {
        id: AnswerType.Boolean,
        name: "Yes/No"
      },
      {
        id: AnswerType.SingleItem,
        name: "Select One"
      },
      {
        id: AnswerType.MultipleItems,
        name: "Select Many"
      }
    ];

    this.attributeTypeIdValue = this.attributeTypes[0].id;
  }
}
</script>

<style scoped></style>
